export default {
  changeCardList(state)
  {
    return state.cardImgkyxmList
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js